/* src/app/components/userandgroup/user/user.component.scss */
:host {
  display: block;
  width: 100%;
  min-width: 0;
}
.users-page-header {
  width: 100%;
}
.users-page-header__content {
  display: flex;
  align-items: center;
  gap: 14px;
}
.users-page-header__icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  background: #eef2ff;
  color: #253b80;
  font-size: 19px;
}
.page-title {
  margin: 0;
  color: #172033;
  font-size: 21px;
  font-weight: 700;
  line-height: 1.25;
}
.page-subtitle {
  margin: 4px 0 0;
  color: #667085;
  font-size: 13px;
}
.user-section {
  width: 100%;
  padding: 0 20px 30px;
  background: #f6f8fc;
}
.container-fluid {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
}
.users-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 18px;
}
.users-toolbar__left {
  flex: 0 0 auto;
}
.users-toolbar__right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
}
.user-summary {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 14px 8px 8px;
  background: #ffffff;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.05);
}
.user-summary__icon {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #eef2ff;
  color: #253b80;
  font-size: 16px;
}
.user-summary__label,
.user-summary__value {
  display: block;
}
.user-summary__label {
  color: #98a2b3;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.user-summary__value {
  margin-top: 2px;
  color: #172033;
  font-size: 17px;
  font-weight: 700;
}
.search-box {
  position: relative;
  display: flex;
  align-items: center;
  width: 270px;
  height: 42px;
  background: #ffffff;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  transition: 0.2s ease;
}
.search-box:focus-within {
  border-color: rgba(37, 59, 128, 0.55);
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.08);
}
.search-box > i {
  position: absolute;
  left: 13px;
  color: #98a2b3;
  font-size: 14px;
}
.search-box input {
  width: 100%;
  height: 100%;
  padding: 0 38px;
  border: 0;
  outline: 0;
  background: transparent;
  color: #172033;
  font-size: 13px;
}
.search-box input::placeholder {
  color: #a0a8b5;
}
.search-clear {
  position: absolute;
  right: 8px;
  width: 26px;
  height: 26px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #98a2b3;
  cursor: pointer;
}
.search-clear:hover {
  background: #f6f8fc;
  color: #172033;
}
.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 42px;
  padding: 0 14px;
  border: 1px solid transparent;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease,
    background 0.15s ease;
}
.action-btn i {
  font-size: 13px;
}
.action-btn:hover {
  transform: translateY(-1px);
}
.action-btn:active {
  transform: translateY(0);
}
.action-btn--primary {
  background: #253b80;
  color: #ffffff;
  box-shadow: 0 3px 8px rgba(37, 59, 128, 0.18);
}
.action-btn--primary:hover {
  background: #1d2f68;
}
.action-btn--secondary {
  background: #ffffff;
  border-color: #e4e7ec;
  color: #253b80;
}
.action-btn--secondary:hover {
  background: #eef2ff;
  border-color: rgba(37, 59, 128, 0.25);
}
.action-btn--success {
  background: #16a34a;
  color: #ffffff;
}
.action-btn--success:hover {
  background: #15803d;
}
.users-card {
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e4e7ec;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.05);
}
.users-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  min-height: 76px;
  padding: 15px 20px;
  border-bottom: 1px solid #eef0f4;
}
.users-card__header h4 {
  margin: 0;
  color: #172033;
  font-size: 15px;
  font-weight: 700;
}
.users-card__header p {
  margin: 4px 0 0;
  color: #667085;
  font-size: 12px;
}
.record-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 11px;
  border-radius: 20px;
  background: #eef2ff;
  color: #253b80;
  font-size: 12px;
  font-weight: 600;
}
.record-badge i {
  font-size: 11px;
}
.table-responsive {
  width: 100%;
  overflow-x: auto;
}
.user-table {
  width: 100%;
  min-width: 900px;
  border-collapse: separate;
  border-spacing: 0;
}
.user-table thead th {
  height: 48px;
  padding: 0 18px;
  background: #fafbfc;
  border-bottom: 1px solid #e4e7ec;
  color: #667085;
  font-size: 11px;
  font-weight: 700;
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.045em;
  white-space: nowrap;
}
.user-table tbody td {
  height: 70px;
  padding: 10px 18px;
  border-bottom: 1px solid #eef0f4;
  color: #172033;
  font-size: 13px;
  vertical-align: middle;
}
.user-table tbody tr {
  transition: background 0.15s ease;
}
.user-table tbody tr:hover {
  background: #fafbff;
}
.user-table tbody tr:last-child td {
  border-bottom: 0;
}
.col-user {
  width: 28%;
}
.col-action {
  width: 135px;
  text-align: center !important;
}
.user-profile {
  display: flex;
  align-items: center;
  gap: 11px;
}
.user-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  overflow: hidden;
  border-radius: 11px;
  background: #eef2ff;
  color: #253b80;
  font-size: 13px;
  font-weight: 700;
}
.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.user-info {
  min-width: 0;
}
.user-info strong {
  display: block;
  overflow: hidden;
  color: #172033;
  font-size: 13px;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-info span {
  display: block;
  margin-top: 3px;
  color: #98a2b3;
  font-size: 11px;
}
.table-value {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #667085;
}
.table-value i {
  color: #98a2b3;
  font-size: 12px;
}
.table-value span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.role-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 9px;
  border-radius: 7px;
  background: #f5f7ff;
  color: #253b80;
  font-size: 11px;
  font-weight: 600;
}
.role-badge i {
  font-size: 10px;
}
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 6px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 650;
}
.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
.status-badge--active {
  background: #ecfdf3;
  color: #15803d;
}
.status-badge--active .status-dot {
  background: #16a34a;
}
.status-badge--inactive {
  background: #f2f4f7;
  color: #667085;
}
.status-badge--inactive .status-dot {
  background: #98a2b3;
}
.table-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.table-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid transparent;
  border-radius: 7px;
  background: transparent;
  cursor: pointer;
  transition: 0.15s ease;
}
.table-action i {
  font-size: 12px;
}
.table-action--status {
  background: #ecfdf3;
  color: #15803d;
}
.table-action--status:hover {
  background: #16a34a;
  color: #ffffff;
}
.table-action--edit {
  background: #fff7ed;
  color: #d97706;
}
.table-action--edit:hover {
  background: #d97706;
  color: #ffffff;
}
.table-action--delete {
  background: #fef2f2;
  color: #dc2626;
}
.table-action--delete:hover {
  background: #dc2626;
  color: #ffffff;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  padding: 35px 20px;
  text-align: center;
}
.empty-state__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  margin-bottom: 13px;
  border-radius: 50%;
  background: #eef2ff;
  color: #253b80;
  font-size: 23px;
}
.empty-state h4 {
  margin: 0;
  color: #172033;
  font-size: 15px;
}
.empty-state p {
  margin: 6px 0 14px;
  color: #667085;
  font-size: 12px;
}
.empty-state__button {
  padding: 8px 13px;
  border: 1px solid #e4e7ec;
  border-radius: 7px;
  background: #ffffff;
  color: #253b80;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.empty-state__button:hover {
  background: #eef2ff;
}
.table-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  min-height: 66px;
  padding: 12px 18px;
  border-top: 1px solid #eef0f4;
}
.pagination-summary {
  color: #667085;
  font-size: 12px;
}
.pagination-summary strong {
  color: #172033;
  font-weight: 650;
}
.page-size {
  display: flex;
  align-items: center;
  gap: 9px;
  color: #667085;
  font-size: 12px;
}
.page-size select {
  min-width: 66px;
  height: 34px;
  padding: 0 25px 0 9px;
  border: 1px solid #e4e7ec;
  border-radius: 7px;
  outline: 0;
  background: #ffffff;
  color: #172033;
  font-size: 12px;
  cursor: pointer;
}
.page-size select:focus {
  border-color: rgba(37, 59, 128, 0.5);
}
.pagination-controls {
  display: flex;
  align-items: center;
}
:host ::ng-deep .ngx-pagination {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 0;
}
:host ::ng-deep .ngx-pagination li {
  margin: 0 !important;
}
:host ::ng-deep .ngx-pagination a,
:host ::ng-deep .ngx-pagination .current {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  min-width: 31px;
  height: 31px;
  padding: 0 8px !important;
  border-radius: 7px !important;
  font-size: 12px !important;
}
:host ::ng-deep .ngx-pagination a {
  color: #667085 !important;
}
:host ::ng-deep .ngx-pagination a:hover {
  background: #eef2ff !important;
  color: #253b80 !important;
}
:host ::ng-deep .ngx-pagination .current {
  background: #253b80 !important;
  color: #ffffff !important;
}
.custom-modal {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: none;
}
.custom-modal.is-active {
  display: block;
}
.custom-modal-overlay {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.58);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
}
.custom-modal-container {
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  flex-direction: column;
  width: min(1080px, 100% - 32px);
  max-height: calc(100vh - 40px);
  overflow: hidden;
  transform: translate(-50%, -50%);
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 20px 60px rgba(16, 24, 40, 0.16);
}
.custom-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  flex: 0 0 auto;
  padding: 20px 24px;
  border-bottom: 1px solid #e4e7ec;
}
.modal-heading {
  display: flex;
  align-items: center;
  gap: 13px;
}
.modal-heading-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  border-radius: 12px;
  background: #eef2ff;
  color: #253b80;
  font-size: 18px;
}
.modal-eyebrow {
  display: block;
  margin-bottom: 3px;
  color: #253b80;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
}
.modal-heading h2 {
  margin: 0;
  color: #172033;
  font-size: 19px;
  font-weight: 700;
}
.modal-heading p {
  margin: 4px 0 0;
  color: #667085;
  font-size: 12px;
}
.modal-close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 8px;
  background: #f5f6f8;
  color: #667085;
  cursor: pointer;
  transition: 0.15s ease;
}
.modal-close-btn:hover {
  background: #fef2f2;
  color: #dc2626;
}
.custom-modal-body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 24px;
  background: #fbfcfe;
  scrollbar-width: thin;
}
.user-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.profile-section {
  width: 100%;
}
.profile-card {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 18px;
  background: #ffffff;
  border: 1px solid #e4e7ec;
  border-radius: 14px;
}
.profile-image-wrapper {
  position: relative;
  width: 82px;
  height: 82px;
  flex: 0 0 82px;
}
.profile-image {
  display: block;
  width: 82px;
  height: 82px;
  object-fit: cover;
  border: 3px solid #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 7px rgba(16, 24, 40, 0.12);
}
.profile-upload-btn,
.profile-remove-btn {
  position: absolute;
  right: -5px;
  bottom: -5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 29px;
  height: 29px;
  border: 3px solid #ffffff;
  border-radius: 50%;
  cursor: pointer;
}
.profile-upload-btn {
  background: #253b80;
  color: #ffffff;
}
.profile-remove-btn {
  background: #dc2626;
  color: #ffffff;
}
.profile-upload-btn i,
.profile-remove-btn i {
  font-size: 10px;
}
.profile-content__label {
  display: block;
  margin-bottom: 4px;
  color: #253b80;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.08em;
}
.profile-content h4 {
  margin: 0;
  color: #172033;
  font-size: 14px;
}
.profile-content p {
  margin: 4px 0 7px;
  color: #667085;
  font-size: 11px;
}
.profile-status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #15803d;
  font-size: 11px;
  font-weight: 600;
}
.profile-status i {
  font-size: 11px;
}
.form-section {
  padding: 20px;
  background: #ffffff;
  border: 1px solid #e4e7ec;
  border-radius: 14px;
}
.section-header {
  display: flex;
  align-items: center;
  gap: 11px;
  padding-bottom: 15px;
  margin-bottom: 17px;
  border-bottom: 1px solid #eef0f4;
}
.section-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  border-radius: 8px;
  background: #eef2ff;
  color: #253b80;
  font-size: 13px;
}
.section-header h3 {
  margin: 0;
  color: #172033;
  font-size: 13px;
  font-weight: 700;
}
.section-header p {
  margin: 3px 0 0;
  color: #667085;
  font-size: 11px;
}
.input-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 17px;
}
.input-group {
  min-width: 0;
}
.input-group.full-width {
  width: 100%;
}
.input-group label {
  display: block;
  margin-bottom: 7px;
  color: #344054;
  font-size: 11px;
  font-weight: 650;
}
.input-group label span {
  color: #dc2626;
}
.input-wrapper,
.textarea-wrapper {
  position: relative;
  width: 100%;
}
.input-wrapper > i,
.textarea-wrapper > i {
  position: absolute;
  left: 12px;
  color: #98a2b3;
  font-size: 12px;
  pointer-events: none;
}
.input-wrapper > i {
  top: 50%;
  transform: translateY(-50%);
}
.input-wrapper input,
.input-wrapper select,
.textarea-wrapper textarea {
  width: 100%;
  border: 1px solid #e4e7ec;
  outline: none;
  background: #ffffff;
  color: #172033;
  font-family: inherit;
  font-size: 12px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.input-wrapper input,
.input-wrapper select {
  height: 40px;
  padding: 0 12px 0 35px;
  border-radius: 8px;
}
.input-wrapper input::placeholder,
.textarea-wrapper textarea::placeholder {
  color: #a4acb9;
}
.input-wrapper input:focus,
.input-wrapper select:focus,
.textarea-wrapper textarea:focus {
  border-color: rgba(37, 59, 128, 0.55);
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.07);
}
.input-wrapper input[readonly] {
  background: #f8fafc;
  color: #667085;
}
.select-wrapper select {
  appearance: none;
  padding-right: 35px;
  cursor: pointer;
}
.select-arrow {
  left: auto !important;
  right: 12px;
  color: #98a2b3 !important;
}
.textarea-wrapper > i {
  top: 13px;
}
.textarea-wrapper textarea {
  display: block;
  min-height: 105px;
  padding: 11px 12px 11px 35px;
  border-radius: 8px;
  resize: vertical;
}
.custom-modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  flex: 0 0 auto;
  min-height: 68px;
  padding: 12px 24px;
  background: #ffffff;
  border-top: 1px solid #e4e7ec;
}
.footer-info {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #667085;
  font-size: 11px;
}
.footer-info i {
  color: #253b80;
}
.footer-info strong {
  color: #dc2626;
}
.footer-actions {
  display: flex;
  align-items: center;
  gap: 9px;
}
.cancel-btn,
.primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  height: 38px;
  padding: 0 15px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
}
.cancel-btn {
  border: 1px solid #e4e7ec;
  background: #ffffff;
  color: #667085;
}
.cancel-btn:hover {
  background: #f8fafc;
  color: #172033;
}
.primary-btn {
  border: 1px solid #253b80;
  background: #253b80;
  color: #ffffff;
  box-shadow: 0 3px 8px rgba(37, 59, 128, 0.18);
}
.primary-btn:hover:not(:disabled) {
  background: #1d2f68;
}
.primary-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}
@media (max-width: 1200px) {
  .users-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
  .users-toolbar__right {
    width: 100%;
    justify-content: flex-start;
  }
  .search-box {
    flex: 1;
    min-width: 240px;
  }
}
@media (max-width: 900px) {
  .input-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .table-pagination {
    flex-wrap: wrap;
  }
}
@media (max-width: 700px) {
  .user-section {
    padding: 14px 0 20px;
  }
  .users-toolbar__right {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
  }
  .search-box {
    grid-column: 1/-1;
    width: 100%;
  }
  .action-btn {
    width: 100%;
  }
  .users-card__header {
    align-items: flex-start;
    flex-direction: column;
  }
  .input-row {
    grid-template-columns: 1fr;
  }
  .custom-modal-container {
    width: calc(100% - 18px);
    max-height: calc(100vh - 18px);
  }
  .custom-modal-header {
    padding: 16px;
  }
  .custom-modal-body {
    padding: 14px;
  }
  .form-section {
    padding: 15px;
  }
  .profile-card {
    align-items: flex-start;
  }
  .custom-modal-footer {
    align-items: stretch;
    flex-direction: column;
    padding: 12px 16px;
  }
  .footer-actions {
    width: 100%;
  }
  .cancel-btn,
  .primary-btn {
    flex: 1;
  }
}
@media (max-width: 480px) {
  .users-toolbar__right {
    grid-template-columns: 1fr;
  }
  .search-box {
    grid-column: auto;
  }
  .user-summary,
  .users-toolbar__left {
    width: 100%;
  }
  .record-badge {
    align-self: flex-start;
  }
  .table-pagination {
    align-items: flex-start;
    flex-direction: column;
  }
  .pagination-summary,
  .page-size,
  .pagination-controls {
    width: 100%;
  }
  .page-size {
    justify-content: space-between;
  }
  .pagination-controls {
    justify-content: center;
  }
  .modal-heading p {
    display: none;
  }
  .modal-heading h2 {
    font-size: 16px;
  }
  .profile-card {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}
/*# sourceMappingURL=user.component.css.map */
